import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { TRANSLATE_PREFIX } from '../../consts';
import RequiredInput from '../RequiredInput';
import css from './MacroCell.css';

const TAB_PREFIX = `${TRANSLATE_PREFIX}.TRACKING_LINK_OPTIONS_TAB`;

const MacroCell = ({ row, setParam, readOnly, translate }) => {
    const { isCustomRow, macroErrorKey, macroWarningKey, index, partner_macro: partnerMacro } = row;
    const placeholderKey = isCustomRow ? `${TAB_PREFIX}.CUSTOM_MACRO_PLACEHOLDER` : `${TAB_PREFIX}.MACRO_PLACEHOLDER`;
    const placeholder = readOnly ? '' : translate(placeholderKey);
    const errorMessage = !readOnly && macroErrorKey ? translate(`${TRANSLATE_PREFIX}.ERRORS.${macroErrorKey}`) : null;
    const warningMessage =
        !readOnly && macroWarningKey ? translate(`${TRANSLATE_PREFIX}.ERRORS.${macroWarningKey}`) : null;

    const input = isCustomRow ? (
        <RequiredInput
            value={partnerMacro || ''}
            placeholder={readOnly ? undefined : placeholder}
            onChange={val => setParam(index, 'partner_macro', val || undefined)}
            inputClassName={classNames({ [css.macroError]: errorMessage })}
            disabled={readOnly}
        />
    ) : (
        <input
            className={classNames(css.macroInput, { [css.macroError]: errorMessage })}
            value={partnerMacro || ''}
            onChange={e => setParam(index, 'partner_macro', e.target.value || undefined)}
            placeholder={placeholder}
            aria-label={placeholder}
            disabled={readOnly}
        />
    );

    return (
        <td>
            {input}
            {errorMessage && <span className={css.macroErrorHint}>{errorMessage}</span>}
            {warningMessage && <span className={css.macroWarningHint}>{warningMessage}</span>}
        </td>
    );
};

MacroCell.propTypes = {
    row: PropTypes.shape({
        isCustomRow: PropTypes.bool.isRequired,
        macroErrorKey: PropTypes.string,
        macroWarningKey: PropTypes.string,
        index: PropTypes.number.isRequired,
        partner_macro: PropTypes.string,
    }).isRequired,
    setParam: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

export default MacroCell;
